<template>
  <el-container>
    <el-main style="width: 70%;">
      <div style="margin-bottom: 30px;">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="item_font">系统设置</el-breadcrumb-item>
          <el-breadcrumb-item><span class="item_font">登录日志</span></el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!--设备列表-->
      <el-table :data="tableData" border highlight-current-row :max-height="maxHeight()" stripe v-loading="diaLoading">
        <el-table-column property="loginDate" label="登录时间"></el-table-column>
        <el-table-column property="loginName" label="登录客服"></el-table-column>
        <el-table-column property="os" label="设备名称"></el-table-column>
        <el-table-column label="最近登录IP/城市">
          <template slot-scope="scope">
            {{scope.row.ip}}/{{scope.row.city}}
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<script>
import {maxHeight} from '../../utils/tableHeight'
export default {
  data() {
    return {
      diaLoading:true,
      tableData:[],
    }
  },

  created() {
  },

  mounted() {
    this.getList();
  },

  methods: {
    maxHeight,
    //列表
    async getList() {
      var api = "/manager/equipment/selectLoginLogByCsid";
      const response =await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
        },
      });
      console.log("*****querySelect *****", response);
      if (response.resultCode == 10000){
        this.diaLoading = false;
        this.tableData = response.data;
      }else{
        this.diaLoading = false;
        this.$message.error(response.desc);
      }
    },
  }
}
</script>

<style scoped="scoped">
.custom_div {
  margin-bottom: 0.9375rem;
}
.custom_div > span  {
  font-size: 0.875rem;
  color: #444444;
}
.talkListBox{width: 100%;overflow: hidden;}
.talkListBox dl{overflow: hidden;margin-bottom: 10px;}
.talkListBox dl dt{width: 100%;height: 30px;background: #eee;padding: 0 20px;box-sizing: border-box;font-size: 14px;line-height: 30px;font-weight: bold;color:darkgreen;}
.talkListBox dl dd.active{background: #f5f5f5;}
.talkListBox dl dd{padding: 5px 20px;overflow: hidden;font-size: 13px;line-height: 25px;font-weight: normal;border-bottom: 1px #ddd dotted;}
.talkListBox dl dd .title{color: #5A9CF8;font-weight: normal;}
.talkListBox dl dd .log{color: blue;}
</style>
